export class NursingNote {
    note: string;
    id: number; 
    authorUserId:number;
   userName:string
   creationDate:Date 
   cditedByUserId:number|null;
   lastRevisedDate:Date|null;
   action:string;
   caseId:number;
  }
  